import { useEffect, useState } from 'react'

import { WEB_QUERY, WIDE_QUERY, isWebLayoutEnabled } from '../utils/breakpoints'

const matches = (query: string) => {
  if (typeof window === 'undefined' || !window.matchMedia) return false
  return window.matchMedia(query).matches
}

const noop = () => undefined

const subscribe = (query: string, onChange: () => void) => {
  if (typeof window === 'undefined' || !window.matchMedia) return noop
  const mql = window.matchMedia(query)
  // Safari < 14 has no addEventListener on MediaQueryList
  if (mql.addEventListener) {
    mql.addEventListener('change', onChange)
    return () => mql.removeEventListener('change', onChange)
  }
  mql.addListener(onChange)
  return () => mql.removeListener(onChange)
}

export const useWebLayout = () => {
  const enabled = isWebLayoutEnabled()

  const [isWeb, setIsWeb] = useState(() => enabled && matches(WEB_QUERY))
  const [isWide, setIsWide] = useState(() => enabled && matches(WIDE_QUERY))

  useEffect(() => {
    if (!enabled) return undefined
    const update = () => {
      setIsWeb(matches(WEB_QUERY))
      setIsWide(matches(WIDE_QUERY))
    }
    update()
    const unsubWeb = subscribe(WEB_QUERY, update)
    const unsubWide = subscribe(WIDE_QUERY, update)
    return () => {
      unsubWeb()
      unsubWide()
    }
  }, [enabled])

  return { isWeb, isWide }
}
